<template>
    <div class="inputWrapper" style="position: relative;">
      <input
        :type="type"
        :class="className"
        :placeholder="placeholder"
        :value="value"
        @input="handleInput"
        class="create_input"
        :onkeyup="onkeyup"
        :onblur="onblur"
        :minlength="minlength"
        :maxlength="maxlength"
        :style="inputStyle"
        :step="step"
        :min="min"
        :max="max"
      />
      <p v-if="popup" class="input__popup">{{ popup }}</p>
    </div>
  </template>
  
  <script>
  export default {
    name: "InputCustom",
    props: ["type", "className", "placeholder", "value", "onkeyup", "onblur", "minlength", "maxlength", "inputStyle", "step", 'min', 'max', 'popup'],
    methods: {
      handleInput(event) {
        if (event.target.value > this.max) {
          this.$emit("input", this.max);
        } else if (event.target.value < this.min) {
          this.$emit("input", this.min);
        } else {
          this.$emit("input", event.target.value);
        }
      },
    },
    model: {
      prop: "value",
      event: "input",
    },
  };
  </script>
  
  <style scoped lang="scss">
  .valid {
    border-color: green;
  }
  .custon_input{
    padding: 0 20px;
    outline: transparent solid 2px;
  }
  .custon_input:focus-visible{
    z-index: 1;
    border-color: #3056d3;
    box-shadow: rgb(49, 130, 206) 0px 0px 0px 1px;
  }
  .custon_input.error {
    color: #f93154 !important;
    border: 1px solid currentColor;
    background: #eec8c8 !important;
  
    animation: shake 0.72s cubic-bezier(0.36, 0.07, 0.19, 0.97) both;
    transform: translate3d(0, 0, 0);
    backface-visibility: hidden;
    perspective: 1000px;
  }
  .input_website{
    height: 32px;
    border-width: 1px;
    border-radius: 6px;
    width: 100%;
    border-style: solid;
    border-color: inherit;
    border-color: #E2E8F0;
    background: inherit;
  }
  .input_website.error {
  color: #f93154 !important;
  border: 1px solid currentColor;
  background: #eec8c8 !important;

  animation: shake 0.72s cubic-bezier(0.36, 0.07, 0.19, 0.97) both;
  transform: translate3d(0, 0, 0);
  backface-visibility: hidden;
  perspective: 1000px;
}
.input_website:focus-visible{
    border-color: rgb(49, 130, 206);
    box-shadow: rgb(49, 130, 206) 0px 0px 0px 1px;
}

.create_input {
  max-width: 312px;
  width: 100%;
  height: auto !important;
  padding: 12px 20px 12px 20px;
  border: 1px solid var(--light-mode-system-grey-4, #d1d1d6);
  color: #828f9a;
  border-radius: 6px;
  font-family: "Inter", sans-serif;
  font-size: 17px;
  font-style: normal;
  font-weight: 400;
  line-height: 22px;
  letter-spacing: -0.17px;
  transition: all 150ms linear;

  &:focus-visible,
  &:hover {
    border-color: rgb(49, 130, 206);
    box-shadow: rgb(49, 130, 206) 0px 0px 0px 1px;
  }
}

.input__popup {
  font-family: inherit;
  position: absolute;
  margin: 0;
  font-size: 12px;
  bottom: -50%;
  left: 0;
  background-color: #fff;
  padding: 5px;
  border: 1px solid var(--light-mode-system-grey-4, #d1d1d6);
  border-radius: 6px;
  transition: all 150ms linear;
  transform: scale(0);

  :focus-visible ~ & {
    transform: scale(1);
  }
}

.empty_field {
  border-color: red;
}

</style>